export const environment = {
  appVersion: '#{{VERSION}}#',
  production: true,
  //api:
  apiUrl: 'https://fd-slp-operator-prod-hthee7c8f2cufhdt.a01.azurefd.net/api',
  apiVersion: '1.0',
  //Okta:
  clientId: '0oa4c3yw88PuHHaP1697',
  issuer: 'https://sightlinepaymentsauth.okta.com/oauth2/aus4c3qbl1qFKgXbe697',
  scopes: ['openid', 'profile', 'email', 'dcxportal-public'],
  pkce: true,
  //Google Analytics:
  measurementId: 'G-NQH0EVMW9B',
  blobSASToken: 'sp=rl&st=2022-09-29T08:36:18Z&se=3020-09-29T16:36:18Z&spr=https&sv=2021-06-08&sr=c&sig=D5cVO1yJiTzREgjSGbg6rOpJwGG%2BEjQpslUhVCcxVOY%3D',
}
 